import { SuspendUserModal } from "./SuspendUserModal";

export default SuspendUserModal;
